import http from "@/api";
//获取字典
export const getDictApi = (dictType: string) => {
  return http.get(`/system/dict/data/type/${dictType}`);
};
